import { ProcessSelectionActionType, ProcessSelectionConfiguration } from '@sdbn/tmc-common';
import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { ProcessSelectOption } from '@sdbn/tmc-common';
import { AppServerAPI } from '@sdbn/common';

export class OnlineterminalCalculateProcessOptionsController extends AbstractStepController {

  private dialogService: DialogService;
  private appServerAPI: AppServerAPI;

  selectOptions = new Array<ProcessSelectOption>();

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selectedProcessOption' && contextChange.value != null) {
      this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedProcessOption'));
    }
  }

  onRegisterToDashboardContext() {
    this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    this.dashboardContext.setContextValue('selectedProcessOption', null);
    this.dashboardContext.setContextValue('dashboardConfiguration', null);
    this.calculateAvailableProcessOptions();
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('onlineterminal calculate available process options started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    return controls;
  }

  private handleSelectedProcessOption(selectedProcessOption: ProcessSelectOption) {
    this.wizardComponent.stopInactivityMonitoring();
    if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_FLOW) {
      this.wizardComponent.handoverToFlow(selectedProcessOption.processFlowKey);
    } else if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_STEP) {
      this.wizardComponent.next(selectedProcessOption.processStepKey);
    } else {
      console.error('Invalid ProcessSelectionActionType' + selectedProcessOption.actionType);
    }
  }


  private calculateAvailableProcessOptions() {
    const instructionsDone = this.dashboardContext.getContextValue('instructionsDone');
    const inviteVisitorsAllowed = this.dashboardContext.getContextValue('inviteAdditionalVisitorsAllowed');
    if (inviteVisitorsAllowed) {
      this.selectOptions.push(new ProcessSelectOption({
        key: 'invite',
        titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.invite-additional-visitors',
        titleIconCss: 'fa-thin fa-people',
        descriptionDictionaryKey: null,
        processFlowKey: this.resolveProcessStepKey('inviteAdditionalVisitor'),
        actionType: ProcessSelectionActionType.PROCESS_FLOW
      }));
    }
    if (instructionsDone) {
      if (this.resolveProcessStepKey('printRegistrationQRCode') != null) {
        this.selectOptions.push(new ProcessSelectOption({
          key: 'print-code',
          titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.print-registration-qrcode',
          titleIconCss: 'fa-thin fa-qrcode',
          descriptionDictionaryKey: null,
          processFlowKey: this.resolveProcessStepKey('printRegistrationQRCode'),
          actionType: ProcessSelectionActionType.PROCESS_FLOW
        }));
      }
    } else {
      this.selectOptions.push(new ProcessSelectOption({
        key: 'instructions',
        titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.start-instructions',
        titleIconCss: 'fa-thin fa-chalkboard-user',
        descriptionDictionaryKey: null,
        processFlowKey: this.resolveProcessStepKey('startInstructions'),
        actionType: ProcessSelectionActionType.PROCESS_FLOW
      }));
    }
    this.dashboardContext.setContextValue('dashboardConfiguration',
      new ProcessSelectionConfiguration({ selectOptions: this.selectOptions }));
  }

  private resolveProcessStepKey(key: string) {
    const config = this.wizardComponent.currentStep.dashboardConfiguration?.flowMapping;
    return config[key];
  }

}
